import React from "react";
import { MessagingScreen } from "../../components/screen/MessagingScreen";
import { useParams } from "react-router-dom";

export function MessagesRoute() {
  const { recipient } = useParams();

  return <MessagingScreen selectedThread={recipient} />;
}
